export default "__VITE_ASSET__adfb9d29__"